export default "__VITE_ASSET__BqY6YKpf__"